module.exports = __webpack_public_path__ + "static/img/tabbar_mine_select@2x.b808219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar_mine_select@2x.png
// module id = gk3c
// module chunks = 1